import UserProfile from "modules/userModule/screens/UserProfile";

export default UserProfile;
